import React, { useEffect, useState } from 'react';
import { useConnectModal, useChainModal } from '@rainbow-me/rainbowkit';
import { useAccount, useChainId } from 'wagmi';

import { Tabs, TabPanel } from 'react-tabs';
import {
    Typography,
    Backdrop,
    Avatar,
    ListItemAvatar,
    CircularProgress,
} from '@mui/material';

import { fetchUserSubmissions } from '../../helpers';

import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ethIcon from '../../assets/images/coin/eth.png';
import bnbIcon from '../../assets/images/coin/bnb.png';
import solIcon from '../../assets/images/coin/sol.png';
import baseIcon from '../../assets/images/coin/base-logo.png';
import avaxIcon from '../../assets/images/coin/avax.png';


// Chain icons mapping (Replace with actual image URLs)
const chainIcons = {
    "1": { icon: ethIcon, name: 'Ethereum' },
    "8453": { icon: baseIcon, name: 'Base' },
    "56": { icon: bnbIcon, name: 'Bsc' },
    "43114": { icon: avaxIcon, name: 'Avalanche' }
};







const SubmissionsHistory = ({ userData }) => {

    const { openConnectModal } = useConnectModal();
    const [submissionHistory, setSubmissionHistory] = useState([])
    const [totalSubmissions, setTotalSubmissions] = useState(0)
    const [totalSubmittedAmount, setTotalSubmittedAmount] = useState(0)
    const { address } = useAccount();
    const [loading, setLoading] = useState(false);

    const containerStyle = {
        marginTop: 0,
        padding: '0 15px',
        width: '100%',
        maxWidth: window.innerWidth < 768 ? '100%' : 900,
        minWidth: window.innerWidth < 768 ? '100%' : 900,
    };

    const tableCell = {
        fontSize: "14px"
    }

    useEffect(() => {
        if (address) {
            handleGetUserData();
        }
    }, [address])

    const handleGetUserData = async () => {
        setLoading(true)
        const submissionsResponse = await fetchUserSubmissions(address);
        if (submissionsResponse.success) {
            if (!isNaN(submissionsResponse.totalSubmissions)) {
                setTotalSubmissions(submissionsResponse.totalSubmissions)
            }
            if (!isNaN(submissionsResponse.totalSubmittedAmount)) {
                setTotalSubmittedAmount(submissionsResponse.totalSubmittedAmount)
            }
            setSubmissionHistory(submissionsResponse.submissions)
        }
        setLoading(false)
    }


    return (
        <>
            <div className="main details" style={{ marginTop: 0 }}>
                <section className="user-profile flat-tabs" style={{ padding: 0 }}>
                    <div className="container" style={{ padding: 0 }}>
                        <div className="row"  >
                            <Tabs style={{ padding: 0 }}>
                                <TabPanel   >
                                    <div className="content-inner profile" style={containerStyle}>
                                        <form action="#"  >
                                            <Typography color="inherit" variant='h5' style={{ color: "#119f24" }}>Submissions History</Typography>
                                            <div className="bt d-flex" style={{ marginBottom: 10, marginTop: 40 }}>
                                                <div className="left">
                                                    <h6 style={{ color: "#119f24" }}>Submissions</h6>
                                                    <ul>
                                                        <li>
                                                            <p>Total submissions</p>
                                                            <p className="text" style={{ color: "#119f24" }}>{totalSubmissions > 1 ? `${totalSubmissions} Tokens` : `${totalSubmissions} Token`} </p>
                                                        </li>
                                                        <li>
                                                            <p>Approved Dumpsters</p>
                                                            <p className="text" style={{ color: "#119f24" }}>0</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="right">
                                                    <h6 style={{ color: "#119f24" }}>Amounts</h6>
                                                    <ul>
                                                        {/* <li>
                                                        <p>Referral Link</p>
                                                        <p className="text">{userData ? userData.referralLink : "No referral link available."}

                                                        </p>
                                                    </li> */}
                                                        <li>
                                                            <p>Total submitted amount</p>
                                                            <p className="text" style={{ color: "#119f24" }}>{totalSubmittedAmount} </p>
                                                        </li>
                                                        <li>
                                                            <p>Current staked amount</p>
                                                            <p className="text" style={{ color: "#119f24" }}>0.00 OSCAR</p>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>

                                            {!address && (
                                                <button
                                                    type="submit"
                                                    className="btn-action"
                                                    onClick={openConnectModal}
                                                    style={{
                                                        padding: "10px",
                                                        fontSize: "12px",
                                                        textTransform: "none",
                                                        borderRadius: "16px",
                                                        gap: "10px",
                                                        color: "white",
                                                    }}
                                                >

                                                    CONNECT WALLET
                                                </button>
                                            )}


                                        </form>
                                    </div>

                                </TabPanel>
                            </Tabs>

                        </div>
                    </div>

                </section>


                <section className="coin-list">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="block-text">
                                </div>

                                <div className="coin-list__main">
                                    <div className="flat-tabs">
                                        <div className="content-tab">
                                            <div className="content-inner">
                                                <table className="table" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                    <thead >

                                                        <tr>
                                                            <th scope="col"></th>
                                                            <th scope="col" style={tableCell}>Chain</th>
                                                            <th scope="col" style={tableCell}>Token Name</th>
                                                            <th scope="col" style={tableCell}>Token Symbol</th>
                                                            <th scope="col" style={tableCell}>Amount</th>
                                                            <th scope="col" style={tableCell}>Submission Date</th>
                                                        </tr>

                                                    </thead>
                                                    <tbody style={{ fontSize: '14px' }}>

                                                        {submissionHistory?.map((item, index) => (
                                                            <tr key={index}>
                                                                <th scope="row">
                                                                    <span className="icon-star"></span>
                                                                </th>
                                                                <td style={tableCell}><ListItemAvatar>
                                                                    <Avatar
                                                                        src={chainIcons[item.chainId] ? chainIcons[item.chainId].icon : PriorityHighIcon}
                                                                        alt={item.chainId}
                                                                        sx={{ width: 30, height: 30 }}
                                                                    />
                                                                </ListItemAvatar></td>

                                                                <td style={tableCell}>{item.name}</td>
                                                                <td style={tableCell}>{item.symbol}</td>
                                                                <td style={tableCell}>{item.amount}</td>
                                                                <td style={tableCell} className="boild">{item.date}</td>
                                                            </tr>
                                                        ))}


                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {!!loading && (
                <Backdrop
                    open={loading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
        </>
    );
};

export default SubmissionsHistory;
